import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as layout from ".";
import { logoutUser } from "../redux/actions/loginUser";
import { fetchUserProfile } from "../redux/actions/profileAction";

const CompleteLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Pull auth state from Redux
  const { isAuthenticated, loggingOut } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logoutUser()).then(() => {
      navigate("/");
    });
  };

  React.useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchUserProfile());
    }
  }, [isAuthenticated, dispatch]);

  return (
    <div className="min-h-screen w-full bg-white flex flex-col relative">
      <header>
        <layout.Navbar
          isAuthenticated={isAuthenticated}
          handleLogout={handleLogout}
          loggingOut={loggingOut}
        />
      </header>
      <main className="flex-grow">
        <Outlet />
      </main>
      <layout.Footer />
    </div>
  );
};

export default CompleteLayout;
